import React, { useState, useEffect } from "react";

import { Chart as MiniChart, ArcElement } from "chart.js";
import { Pie } from "react-chartjs-2";
import "./MiniPieChart.scss";
MiniChart.register(ArcElement);
const MiniPieChart = ({ data = [], height = 60, onSelectItem }: any) => {
  const [chartData, setChartData] = useState(null as any);
  const [sortedData, setSortedData] = useState([] as any[]);

  const convertToChartData = (originalData: any) => {
    const labels = originalData.map((item: any) => item.label);
    const data = originalData.map((item: any) => item.value);
    const backgroundColor = originalData.map((item: any) => item.color);

    const chartData = {
      labels: labels,
      datasets: [
        {
          data: data,
          backgroundColor: backgroundColor,
        },
      ],
    };

    return chartData;
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
    onClick: (event: any, elements: any) => {
      if (elements.length > 0) {
        const sortedIndex = elements[0].index;
        // Encontrar el índice original en los datos no ordenados
        const originalItem = sortedData[sortedIndex];
        const originalIndex = data.findIndex((item: any) =>
          item.label === originalItem.label &&
          item.value === originalItem.value
        );
        onSelectItem(originalIndex);
      }
    },
  };

  useEffect(() => {
    const sorted = [...data].sort((a: any, b: any) => b.value - a.value);
    setSortedData(sorted);
    setChartData(convertToChartData(sorted));
  }, [data]);

  return (
    <div className="mini-pie-chart-container">
      <div className="graph" style={{ height: height + "px" }}>
        {chartData && (
          <Pie
            data={chartData}
            options={options}
          />
        )}
      </div>
    </div>
  );
};

export { MiniPieChart };
